import { KTX2Loader } from 'three/addons/loaders/KTX2Loader.js'

let ktxLoader = null

function getLoader() {
    if (ktxLoader) return ktxLoader
    ktxLoader = new KTX2Loader()
    ktxLoader.setTranscoderPath(import.meta.env.BASE_URL + 'loader/basis/')
    return ktxLoader
}

export default async function loadKTX2(url) {
    return new Promise((resolve, reject) => {
        getLoader().load(url, resolve, undefined, reject)
    })
}

loadKTX2.detectSupport = (renderer) => getLoader().detectSupport(renderer)

loadKTX2.loader = {
    name: 'ktx2',
    extensions: ['.ktx2', '.basis'],
}
